import { p as proxyCustomElement, H, h } from './p-bfa0dc67.js';
import { c as classNames } from './p-df8c8ec2.js';
import { d as defineCustomElement$3 } from './p-fbb8407b.js';
import { d as defineCustomElement$2 } from './p-133d1979.js';

const biAccordionHeaderCss = ".sr-only{position:absolute;height:1px;width:1px;padding:0;margin:-1px;overflow:hidden;border:0;left:-9999px;text-indent:-5000px;clip:rect(1px, 1px, 1px, 1px);}*,*:before,*:after{box-sizing:border-box}html,body,div,span,object,iframe,figure,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,code,em,img,small,strike,strong,sub,sup,tt,b,u,i,ol,ul,li,fieldset,form,label,table,caption,tbody,tfoot,thead,tr,th,td,main,canvas,embed,footer,header,nav,section,button,video{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;text-size-adjust:none}footer,header,nav,section,main{display:block}body{line-height:1.5}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:before,blockquote:after,q:before,q:after{content:\"\";content:none}table{border-collapse:collapse;border-spacing:0}input{-webkit-appearance:none;appearance:none;border-radius:0}:host(:focus){outline:none !important;border:none !important}.accordion-header{display:flex;grid-auto-flow:column;align-items:flex-start;justify-content:flex-start;position:relative;color:inherit}.accordion-header.small{font-size:0.75rem;line-height:1.5}.accordion-header.medium{font-size:1rem;line-height:1.5}.accordion-header.large{font-size:1.25rem;line-height:1.5}.accordion-header button{background-color:inherit;border:unset;width:100%;color:inherit;z-index:1;position:relative;cursor:pointer;padding:unset;height:2rem}.accordion-header button:focus-visible{border-radius:4px;outline-offset:2px;outline:1.5px solid var(--bi-primary-50);box-shadow:0 0 0 2px white}.accordion-header .title{display:flex;flex-direction:row;justify-content:space-between;font-size:inherit;line-height:inherit;width:100%;text-align:start;align-items:center}.accordion-header ::slotted(bi-link){z-index:2;position:relative;height:100%}";
const BiAccordionHeaderStyle0 = biAccordionHeaderCss;

const BiAccordionHeader$1 = /*@__PURE__*/ proxyCustomElement(class BiAccordionHeader extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.accordionElement = null;
        /**
         * Size of the accordion header.
         * @default 'medium'
         */
        this.size = 'medium';
        this.toggleHeader = () => {
            this.accordionElement?.toggle();
        };
    }
    async updateIsExpanded() {
        this.isExpanded = this.accordionElement?.isExpanded;
    }
    componentWillRender() {
        this.accordionElement = this.el.parentElement;
        this.updateIsExpanded();
    }
    componentDidLoad() {
        const biLink = this.el.querySelector('bi-link');
        if (biLink) {
            biLink.addEventListener('click', (event) => {
                // Check if the clicked element is or is inside a bi-link
                const path = event.composedPath();
                const isBiLinkInteraction = path.some((elem) => elem.tagName === 'BI-LINK');
                if (isBiLinkInteraction) {
                    // Prevent the accordion toggle function, execute link-specific logic
                    event.stopImmediatePropagation();
                }
            });
        }
    }
    render() {
        return (h("div", { key: 'd9f8ff976172d090eb317f1b73d823ca58cbba28', class: classNames('accordion-header', this.size) }, h("button", { key: 'd46be2f9a30de2efda688e96f30c91756b2d015b', class: 'title', onClick: this.toggleHeader, "aria-expanded": String(this.isExpanded) }, h("slot", { key: 'd46a656f3172fe08b62c324dcfe9e930f82b0804' }), this.isExpanded ? (h("bi-icon-chevron-up", { size: 'large', color: 'black', "aria-hidden": 'true' })) : (h("bi-icon-chevron-down", { size: 'large', color: 'black', "aria-hidden": 'true' })))));
    }
    get el() { return this; }
    static get style() { return BiAccordionHeaderStyle0; }
}, [1, "bi-accordion-header", {
        "size": [1],
        "isExpanded": [32],
        "updateIsExpanded": [64]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-accordion-header", "bi-icon-chevron-down", "bi-icon-chevron-up"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-accordion-header":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiAccordionHeader$1);
            }
            break;
        case "bi-icon-chevron-down":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "bi-icon-chevron-up":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const BiAccordionHeader = BiAccordionHeader$1;
const defineCustomElement = defineCustomElement$1;

export { BiAccordionHeader, defineCustomElement };
